import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

const initialState = {
  syncResult: null,
  isLoadSync: false,
};

export const createSyncTiki = createAsyncThunk(
  "Tiki/createSyncTiki",
  async (data) => {
    const response = await http.post("/add-item-tiki", data);
    return response.data.data;
  }
);

export const checkPendingTiki = createAsyncThunk(
  "Tiki/checkPendingTiki",
  async (_, { rejectWithValue }) => {
    const response = await http.post("/check-pending-tiki");
    const data = response.data?.data ?? response.data;
    if (response.data?.status !== 200 && response.data?.status !== undefined) {
      return rejectWithValue(data?.message || "Failed");
    }
    return data;
  }
);

const syncTiki = createSlice({
  name: "syncTiki",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createSyncTiki.pending, (state) => {
        state.isLoadSync = true;
      })
      .addCase(createSyncTiki.fulfilled, (state, action) => {
        state.syncResult = action.payload;
        state.isLoadSync = false;
      })
      .addCase(createSyncTiki.rejected, (state) => {
        state.isLoadSync = false;
      })
      .addCase(checkPendingTiki.fulfilled, () => {})
      .addCase(checkPendingTiki.rejected, () => {});
  },
});

export default syncTiki.reducer;
